import { render } from "./leave-type.vue?vue&type=template&id=8ad0c4fa"
import script from "./leave-type.vue?vue&type=script&lang=js"
export * from "./leave-type.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__